// @flow
import { useMutation, type MutationResult } from 'react-query';

import useClientId from 'common/hooks/useClientId';
import queryClient from 'common/middleware/queryClient';

import { pregenWaybillBulkCreate as pregenWaybillBulkCreateApi } from 'platform/settings/modules/orchestration/api';
// eslint-disable-next-line max-len
import { WaybillBulkCreateResponse } from 'platform/settings/modules/orchestration/models/internal/WaybillBulkCreateResponse';

type Params = {
    carrierId: string,
    serviceType: string,
    waybillNumbers: Array<string>
};

const useWaybillBulkCreate = (): MutationResult<
    Params,
    WaybillBulkCreateResponse
> => {
    const clientId = useClientId();

    return useMutation(
        async (params: Params) => {
            const data = await pregenWaybillBulkCreateApi.post(
                { clientId },
                params
            );

            return WaybillBulkCreateResponse.fromJS(data);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries([
                    'client',
                    clientId,
                    'waybill-unused-summary'
                ]);
            }
        }
    );
};

export default useWaybillBulkCreate;
